/* @flow */

import BankAccount from 'models/companies/bankAccount';

export default class InvestmentProfileValues {
  name: string;
  bankAccount: BankAccount;
  amount: number;
  minInvoiceAmount: number;
  maxInvoiceAmount: number;
  comment: string;
  marketPlace: string;
  automaticBuying: boolean;
  showAutomaticBuyingSign: boolean;
}
